import React from 'react';

const NominateClgBtn = () => {

    return (
        <>
            {/* {props.isSuccessMsg
                ?
                <div className="alert alert-success mt-2 fs-5">
                    <strong>Thank you for nominating your School.</strong>
                </div>
                : */}
                <div className="input-email input-email-gr mb-4 mt-0">
                    <div className="d-flex">
                        {/* <input
                            name="principal_email"
                            type="email" 
                            placeholder="Principal’s email"
                            value={props.schoolFields.email}
                            onChange={(event) => props.onChangeText('school', 'email', event.target.value)}
                        /> */}
                        <a className="w-100" href="/fellowships/application">
                        <button
                            className="w-100"
                            // onClick={(e) => props.nominateSchool(e)}
                            // disabled={props.isFormProcess.school}
                        >
                            {/* {props.isFormProcess.school && (
                                <><LoaderMedium size={10} />&nbsp;</>
                            )} */}
                            Nominate Your School
                        </button>
                        </a>
                    </div>
                </div>
            {/* } */}
        </>
    );
}

export {
    NominateClgBtn
};